/**
 * The front desk's two panels for visits that have no time yet: the WAITING
 * LIST (`shared/schedule/ScheduleWaitingPanel`) and SEVERAL VISITS in one
 * order (`shared/schedule/ScheduleSequencePanel`). Both are reception work
 * over the same booking checks as any other appointment; nothing here names
 * a payment, a coverage or an exception.
 */
export const scheduleWaiting = {
  'schedule.waiting.title': 'Waiting list',
  'schedule.waiting.action': 'Waiting list',
  'schedule.waiting.new': 'New request',
  'schedule.waiting.edit': 'Edit request',
  'schedule.waiting.unsaved': 'Waiting list request',
  'schedule.waiting.status': 'Status',
  'schedule.waiting.status.open': 'Open',
  'schedule.waiting.status.booked': 'Booked',
  'schedule.waiting.status.withdrawn': 'Withdrawn',
  'schedule.waiting.anyPatient': 'All patients',
  'schedule.waiting.clinician': 'Desired clinician',
  'schedule.waiting.anyClinician': 'Any clinician',
  'schedule.waiting.from': 'Earliest day',
  'schedule.waiting.to': 'Latest day',
  'schedule.waiting.window': '{from} – {to}',
  'schedule.waiting.note': 'Preferences',
  'schedule.waiting.missingInput': 'Choose a patient, a visit type and the days that suit, latest day not before the earliest.',
  'schedule.waiting.create': 'Add to waiting list',
  'schedule.waiting.save': 'Save request',
  'schedule.waiting.book': 'Book',
  'schedule.waiting.withdraw': 'Withdraw',
  'schedule.waiting.withdrawTitle': 'Withdraw this request?',
  'schedule.waiting.withdrawDescription': 'The request stays on record as withdrawn. No appointment changes.',
  'schedule.waiting.withdrawConfirm': 'Withdraw request',
  'schedule.waiting.created': 'Added to the waiting list',
  'schedule.waiting.saved': 'Request saved',
  'schedule.waiting.withdrawn': 'Request withdrawn',
  'schedule.waiting.updated': 'Updated {time}',
  'schedule.waiting.empty': 'No requests',
  'schedule.waiting.emptyDetail': 'Nothing is waiting under these filters.',
  'schedule.waiting.loading': 'Loading the waiting list',
  'schedule.waiting.loadFailed': 'The waiting list could not be loaded',
  'schedule.waiting.more': 'Show more',
  'schedule.sequence.title': 'Several visits',
  'schedule.sequence.action': 'Several visits',
  'schedule.sequence.unsaved': 'Several visits in one order',
  'schedule.sequence.from': 'First day',
  'schedule.sequence.span': 'Days to search',
  'schedule.sequence.span.day': 'One day',
  'schedule.sequence.span.week': 'Seven days',
  'schedule.sequence.notBefore': 'Not before',
  'schedule.sequence.visits': 'Visits in order',
  'schedule.sequence.visit': 'Visit {n}',
  'schedule.sequence.addVisit': 'Add visit',
  'schedule.sequence.removeVisit': 'Remove visit {n}',
  'schedule.sequence.moveUp': 'Move visit {n} earlier',
  'schedule.sequence.moveDown': 'Move visit {n} later',
  'schedule.sequence.limit': 'Up to eight visits in one order, within seven days.',
  'schedule.sequence.missingInput': 'Choose a patient, the first day and a visit type for every visit to search.',
  'schedule.sequence.search': 'Find times',
  'schedule.sequence.searching': 'Searching for the visits in order',
  'schedule.sequence.failed': 'The search could not be completed',
  'schedule.sequence.proposal': 'Proposed times',
  'schedule.sequence.previewNote': 'A proposal reserves nothing until it is booked.',
  'schedule.sequence.incomplete': 'No complete sequence was found',
  'schedule.sequence.incompleteDetail': 'This bounded search found no whole proposal. Change the days, the order or the resource choices and search again.',
  'schedule.sequence.stale': 'The inputs changed. Search again before booking.',
  'schedule.sequence.book': 'Book all visits',
  'schedule.sequence.visitFloor': 'This visit not before',
  'schedule.sequence.visitFloorDay': 'This visit not before, day',
  'schedule.sequence.floorNote': 'A visit’s own earliest start searches the whole order again; it and the visits after it may land later to keep the order.',
  'schedule.sequence.floorInvalid': 'A visit’s earliest start must be a time the clinic’s zone has, on a day within the searched days.',
} as const
